import Task from '../index'

// 获取详情时,把injured的数据挪到injuredInfo,提交任务和暂存时,把injuredInfo挪到injured
// reverse为true,指获取详情时的情况
export function formatOrder(order, reverse) {
	let target = order.injured
	let source = order.injuredInfo
	if (reverse) {
		target = order.injuredInfo
		source = order.injured
	}
	;['treatment', 'treatWays', 'referralWays'].forEach(item => {
		target[item] = source[item]
	})
}

// 格式化订单详情
export function initOrderDetail(data) {
	const task = new Task({
		propsData: {
			order: data.order,
		},
	})
	if (task.isHomeInvestigate) {
		return data.operation
	}
	const injured = data.injured || {}

	if (data.operation) {
		Object.assign(injured, data.operation)
	}

	if (!Object.prototype.hasOwnProperty.call(injured, 'injured')) {
		injured.injured = {}
	}

	if (!Object.prototype.hasOwnProperty.call(injured, 'injuredInfo')) {
		injured.injuredInfo = {}
	}

	if (!Object.prototype.hasOwnProperty.call(injured, 'agent')) {
		injured.agent = {
			hasAgent: '1',
		}
	}

	;[
		'censusRegisterAddress',
		'censusRegisterType',
		'birthday',
		'idNo',
		'idType',
		'name',
		'phone',
		'selfPhone',
		'referralWays',
		'sex',
		'treatWays',
		'treatment',
		'age',
		'inHospital',
		'goPlace',
		'emergencyName',
		'relationShip',
		'emergencyPhone',
		'otherInsurance',
		'otherInsuranceDesc',
		'medicalInsurance',
	].forEach(item => {
		injured.injured[item] = injured[item]
		delete injured[item]
	})

	formatOrder(injured, true)

	return injured
}

export function hasValue(value) {
	return (value && String(value).trim()) || value === 0
}
